import { mount } from 'svelte';
import App from '../cart/index.svelte';

const target = document.getElementById('cart_app');
const props = window.cartProps || {};

window.cart = mount(App, { target, props });
